// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.terminal-container {
    background: #0d1117;
    padding: 10px;
    border-radius: 8px;
    box-shadow: 0 10px 30px rgba(0,0,0,0.5);
    max-width: 1000px;
    margin: 20px auto;
    border: 1px solid #30363d;
}

.terminal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 15px;
    color: #c9d1d9;
    font-size: 13px;
    border-bottom: 1px solid #30363d;
    font-weight: 600;
}

.terminal-body {
    height: 500px;
    width: 100%;
    margin-top: 10px;
    background: #000;
    overflow: hidden;
}

.status-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
}

.status-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
}

.status-dot.online { background: #238636; box-shadow: 0 0 8px #238636; }
.status-dot.offline { background: #da3633; box-shadow: 0 0 8px #da3633; }

.status-text {
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 1px;
}
`, "",{"version":3,"sources":["webpack://./src/components/DiagnosticTools/WebTerminal.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,uCAAuC;IACvC,iBAAiB;IACjB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;AACtB;;AAEA,qBAAqB,mBAAmB,EAAE,2BAA2B,EAAE;AACvE,sBAAsB,mBAAmB,EAAE,2BAA2B,EAAE;;AAExE;IACI,eAAe;IACf,yBAAyB;IACzB,mBAAmB;AACvB","sourcesContent":[".terminal-container {\n    background: #0d1117;\n    padding: 10px;\n    border-radius: 8px;\n    box-shadow: 0 10px 30px rgba(0,0,0,0.5);\n    max-width: 1000px;\n    margin: 20px auto;\n    border: 1px solid #30363d;\n}\n\n.terminal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 8px 15px;\n    color: #c9d1d9;\n    font-size: 13px;\n    border-bottom: 1px solid #30363d;\n    font-weight: 600;\n}\n\n.terminal-body {\n    height: 500px;\n    width: 100%;\n    margin-top: 10px;\n    background: #000;\n    overflow: hidden;\n}\n\n.status-wrapper {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.status-dot {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n}\n\n.status-dot.online { background: #238636; box-shadow: 0 0 8px #238636; }\n.status-dot.offline { background: #da3633; box-shadow: 0 0 8px #da3633; }\n\n.status-text {\n    font-size: 10px;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
